import {component} from '@o2oa/o2core-js';
import './taskItem.css';

const template = `<div class="taskItem_content mainColor_bg" data-o2-element="itemNode" data-o2-events="click:setCurrent">
    <div class="taskItem_text">{{$.name}}</div>
    <div class="taskItem_action o2icon-close" data-o2-events="click:close"></div>
</div>`;

export default component({
    reuse: true,
    template,
    bind: {},
    module: {
        unCurrent(){
            this.itemNode.removeClass("mainColor_bg");
            this.itemNode.addClass("grayColor_bg");
        },
        current(){
            this.itemNode.addClass("mainColor_bg");
            this.itemNode.removeClass("grayColor_bg");
        },
        setUnCurrent(){
            this.unCurrent()
            if (this.component.app) this.component.app.hide();
        },
        setCurrent(){
            if (this.component.contentApp) this.component.contentApp.setCurrentComponent(this.component.app);
            this.current();
            if (this.component.app) this.component.app.show();
        },
        close(e){
            if (this.component.contentApp){
                this.component.contentApp.currentComponent = null;
                for (let key in this.component.contentApp.components) {
                    if (this.component.app === this.component.contentApp.components[key]) {
                        delete this.component.contentApp.components[key];
                    }
                }
            }
            const keys = Object.keys(this.component.contentApp.components)
            if (keys[0]) this.component.contentApp.components[keys[0]].taskItem.module.setCurrent();


            if (this.component.app) this.component.app.destroy();
            this.component.destroy();

            e.stopPropagation();
        }
    }
});
